module.exports = __webpack_public_path__ + "static/media/pause.154ff067.svg";